import { Spinner } from '@/components/Spinner';
import { useMemo } from 'react';
import { ManageSubGroupForm } from './ManageSubGroupForm';
import { useSubGroupDetail } from './hooks/useSubGroupDetail';

const ManageSubGroupFormContainer = ({
  groupId,
  subGroupId,
  defaultValues,
}: {
  groupId?: string;
  subGroupId?: string;
  defaultValues?: {
    groupName: string;
    groupNameKatakana: string;
    subGroupName?: string;
  };
}) => {
  const { subGroupDetail, isLoading } = useSubGroupDetail(subGroupId || '');

  const formDefaultValues = useMemo(
    () => ({
      groupName: subGroupDetail?.groupName ?? defaultValues?.groupName ?? '',
      groupNameKatakana: subGroupDetail?.groupNameKatakana ?? defaultValues?.groupNameKatakana ?? '',
      subGroupName: subGroupDetail?.subGroupName ?? '',
    }),
    [subGroupDetail],
  );

  if (isLoading) return <Spinner />;

  return <ManageSubGroupForm groupId={groupId} subGroupId={subGroupId} defaultValues={formDefaultValues} />;
};

export default ManageSubGroupFormContainer;
